import { ContentBlockViewComponent, ContentModule } from '@tytapp/content';
import { NewsletterSignupBlock } from './newsletter-signup-block';
import { Component } from '@angular/core';

@Component({
    selector: 'tyt-newsletter-signup-block',
    standalone: true,
    imports: [ ContentModule ],
    template: `
        <tyt-content-card title="Newsletter" [icon]="{ type: 'image', url: '/assets/icons-2019/newsletters.svg' }">
            <tyt-newsletter-module />
        </tyt-content-card>
    `
})
export class ViewComponent extends ContentBlockViewComponent<NewsletterSignupBlock> {
}
